import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { KeyIdentifier, MessageItem, MessageItemType, SingleMessageClass } from './message-center.model';

const SingleMessages: { [key: string]: Partial<MessageItem> } = {
  ['splitReview']: {
    message: 'detailsErrors.miscMessages.baseMsg',
    params: {
      navMessage: 'detailsErrors.miscMessages.splitReview',
      route: 'records/property/{recordId}/split-review',
    },
  },
};

export class AddSingleMessage implements ExecutableAction<MessageItem[]> {
  static readonly type = '[Message Center] Add Single Message';

  static Warning(keyIdentifier: KeyIdentifier, id?: number) {
    return new AddSingleMessage(
      MessageItemType.misc,
      keyIdentifier,
      SingleMessages[keyIdentifier],
      SingleMessageClass.Warning,
      id
    );
  }

  constructor(
    private type: MessageItemType,
    private keyIdentifier: KeyIdentifier,
    private message: Partial<MessageItem>,
    private className: string,
    private id: number
  ) {
    if (this.message.params.route && this.id) {
      this.message.params.route = this.message.params.route.replace('{recordId}', this.id.toString());
    }
  }

  execute(params: ExecutableActionParam<MessageItem[]>): void {
    const state = params.ctx.getState();

    // * If message already exist don't add to the stack...
    if (state.some(message => message.identifier === this.keyIdentifier)) {
      params.ctx.setState(state);
      return;
    }

    const { params: msgParams } = this.message;

    const newMessage: MessageItem = {
      ...this.message,
      params: {
        ...msgParams,
        className: this.className,
      },
      type: this.type,
      identifier: this.keyIdentifier,
    };

    const nextState = [...state, newMessage];
    params.ctx.setState(nextState);
  }
}
